<template>
  <NoItem v-if="noItem" />
  <div v-else>
    <v-container v-if="profile">
      <v-row class="align-center">
        <OpAvatar
          class="mr-2"
          :size="50"
          :profile="profile"
        />
        <UserFullName
          class="text-h5"
          :profile="profile"
        />
      </v-row>

      <v-row>
        <div class="mt-3 text-caption text-grey">
          {{ $t('User.FormInfo.ChangeEmailAndRestore') }}
        </div>
      </v-row>

      <v-row>
        <TextInput
          v-model="formData.email"
          field-key="email"
          :label="$t('User.EmailAddress')"
          required
          autocomplete="off"
          class="mt-2"
        />
      </v-row>

      <v-row>
        <v-spacer />
        <v-btn
          color="primary"
          @click="submit()"
        >
          {{ $t('User.RestoreUser') }}
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NoItem from '@/components/content/NoItem'
import OpAvatar from '@/components/parts/OpAvatar'
import UserFullName from '@/components/parts/UserFullName'
import TextInput from '@/components/parts/inputs/TextInput'

export default {
  components: {
    TextInput,
    UserFullName,
    OpAvatar,
    NoItem
  },
  props: {
    home: Boolean
  },
  data: () => ({
    profile: null,
    noItem: false,
    formData: {
      email: ''
    }
  }),
  computed: {
    ...mapGetters(['login']),
    userId () {
      return this.$route.params.id ? this.$route.params.id : this.login.user_id
    },
    isMyself () {
      if (this.profile) {
        return this.profile.id === this.login.user_id
      } else {
        return false
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.profile = null
      this.get()
    }
  },
  created () {
    this.get()
  },
  methods: {
    get () {
      this.$http(`deleted-users/${this.userId}/`).then(
        (res) => {
          this.profile = res.data
          this.formData.email = res.data.email.slice(res.data.email.indexOf('_') + 1)
        },
        (error) => {
          if (error.response.status === 404) {
            this.noItem = true
          }
        })
    },
    submit () {
      this.$http.put(`deleted-users/${this.userId}/`, this.formData).then(
        (res) => {
          this.$router.push({ path: '/deleted-manage-accounts' })
        },
        (error) => {
          console.error(error)
        })
    }
  }
}
</script>

<style scoped>

</style>
